import { getTypedState } from 'ducks/hooks'
import { PriceItem, Territory } from 'ducks/types'

export const getRepairItems = () => (): PriceItem[] => {
  const { territories } = getTypedState()
  if (!territories?.repairItems || !territories.repairItems.length) return []
  return territories.repairItems
}

export const getTerritory = () => (): Territory | null => {
  const { territories } = getTypedState()
  const territory = territories?.territory || null
  return territory || null
}

export const getTerritories = () => (): Territory[] => {
  const { territories } = getTypedState()
  return territories?.territories || []
}
